import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import deletedEventService from '../services/deletedEventService';

const deletedEventsCollectionName = "deleted_events";

export const useDeletedEventData = () => {
  return useQuery({
    queryKey: [deletedEventsCollectionName],
    queryFn: () => deletedEventService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useRestoreDeletedEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (deletedEventId) => deletedEventService.restore(deletedEventId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [deletedEventsCollectionName] });
      queryClient.invalidateQueries({ queryKey: ['events'] });

    },
  });
};

export const useDeleteDeletedEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (deletedEventId) => deletedEventService.delete(deletedEventId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [deletedEventsCollectionName] });
    },
  });
};